import { useCallback } from 'react';

/**
 * Copies text, returning whether it worked.
 *
 * navigator.clipboard is unavailable outside a secure context, so a hidden
 * textarea plus execCommand is kept as a fallback. Callers decide what to
 * report, since a silent failure here is worse than a visible one.
 */
export default function useCopyToClipboard() {
  return useCallback(async (text) => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch {
      // Permission denied or insecure context — fall through.
    }

    try {
      const area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(area);
      return ok;
    } catch {
      return false;
    }
  }, []);
}
